import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../../services/customer_appCommonService";
import logistics from "../../../../../services/logistics_appCommonService";
//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import {
  formatDate,
  validateName,
  validPostalCode,
} from "../../../../../common/Validations";
import toast from "react-hot-toast";
import FileUploadComponent from "../../../../../Components/formElements/FileUploadComponent";
import Layout from "../../../../../Layout/Layout";
import FileViewerModal from "../../../../../Components/FileViewer/FileViewerModal";
import LogisticsConstants from "../../../../../common/LogisticsConstants";
import DataTable from "react-data-table-component";
import VehicleServiceHistory from "./PlVehicleServiceHistory";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const PlVehicleDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Vehicle");

  let userData = useSelector((state) => state?.logistics?.data);
  let vehicleID = useSelector((state) => state?.logistics?.vehicle?.vehicleNr);

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const typeOptions = [
    { id: 1, name: "Hired", textField: "type" },
    { id: 2, name: "Own", textField: "type" },
  ];
  const noOfTyresOptions = [
    { id: 1, name: "4", textField: "noOfTyres" },
    { id: 2, name: "6", textField: "noOfTyres" },
    { id: 3, name: "8", textField: "noOfTyres" },
    { id: 4, name: "10", textField: "noOfTyres" },
    { id: 5, name: "12", textField: "noOfTyres" },
    { id: 6, name: "14", textField: "noOfTyres" },
    { id: 7, name: "16", textField: "noOfTyres" },
  ];
  const statePermitOptions = [
    { name: "Yes", textField: "statePermit" },
    { name: "No", textField: "statePermit" },
  ];
  const nationalPermitOptions = [
    { name: "Yes", textField: "nationalPermit" },
    { name: "No", textField: "nationalPermit" },
  ];
  const refVehicleOptions = [
    { id: 1, name: "Yes", textField: "type1" },
    { id: 2, name: "No", textField: "type1" },
  ];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [getFuelHistory, setFuelHistory] = useState();
  // eslint-disable-next-line no-unused-vars
  const [getupdateLogisticsTransport, setupdateLogisticsTransport] = useState();

  //renewalDueOn
  const [getRenewalDueOn, setRenewalDueOn] = useState([]);

  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  // eslint-disable-next-line no-unused-vars

  const [getdocumentType, setdocumentType] = useState([]);

  const [getDisabled, setDisable] = useState(false);

  const [validation, setValidation] = useState({
    organisationName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  //fuel Historical Table
  const fuelHistoryColum = [
    {
      name: "Fuel No",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Filled Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.filledDate)}{" "}
          </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Bunk",
      selector: (row) => row.bunk || "--",
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold">{row.bunk} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver",
      selector: (row) => row.driverName,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.driverName} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver Contact",
      selector: (row) => row.driverContactNr || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Liters",
      selector: (row) => row.liters || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Amount",
      selector: (row) => row.totalAmount || "--",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.totalAmount}</p>
            {/* <p className="m-0 p-0">{row.currencyCode}</p> */}
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Old Reading",
      selector: (row) => row.oldReading || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "New Reading",
      selector: (row) => row.newReading,
      sortable: true,
      width: "130px",
    },
    {
      name: "Usage Reading",
      selector: (row) => row.usageReading,
      sortable: true,
      width: "140px",
    },
    {
      name: "Mileage",
      selector: (row) => Number(row.mileage).toFixed(2),
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {Number(row.mileage).toFixed(2)}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Attachments",
      selector: (row) => row.billDocument,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          {row.billDocument && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.billDocument)}
            />
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];
  //service history
  const serviceHistoryColumn = [
    {
      name: "Service ID",
      selector: (row) => row?.serviceId || "--",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status">
          {row.serviceId}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Date",
      selector: (row) => row?.serviceDate || "--",
      cell: (row) => <p className="m-0 p-0 pt-1 fw-bold">{row.serviceDate}</p>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Center",
      selector: (row) => row?.serviceCenter || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Service Type",
      selector: (row) => row?.serviceType || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Odometer Reading",
      selector: (row) => row?.odometerReading || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Issues Reported",
      selector: (row) => row?.issuesReported || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Work Performed",
      selector: (row) => row?.workPerformed || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Parts Replaced",
      selector: (row) => row?.partsReplaced || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Total Cost",
      selector: (row) => row?.totalCost || "--",
      cell: (row) => <p className="m-0 p-0 fw-bold">{row.totalCost}</p>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Next Service Due",
      selector: (row) => row?.nextServiceDue || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 text-primary fw-bold">
          {row.nextServiceDue}
        </p>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Invoice Number",
      selector: (row) => row?.invoiceNumber || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks || "--",
      sortable: true,
      width: "200px",
    },
  ];

  //bank state
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    vehicleRegistrationNr: "",
    registrationDate: "",
    manufactureMake: "",
    chassisNr: "",
    engineNr: "",
    capacityMT: "",
    noOfTyres: "",
    statePermit: "",
    statePermitDate: "",
    nationalPermit: "",
    nationalPermitDate: "",
    roadTax: "",
    type: "",
    transporter: "",
    ownername: "",
    makeModel: "",
    type1: "",
    refvehicleRegistrationNr: "",
    refregistrationDate: "",
    refmanufactureMake: "",
    refchassisNr: "",
    refmakeModel: "",
    refengineNr: "",
    refnoOfTyres: "",
    refownername: "",
    reftype: "",
    reftransporter: "",

    refstatePermit: "",
    refstatePermitDate: "",
    refnationalPermit: "",
    refnationalPermitDate: "",
    refroadTax: "",
    reffitness: "",
    refinsuranceNr: "",
    refinsuranceExpiryDate: "",
    refPollution: "",
    refAmc: "",
  });

  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const onInputChangerenewalDueOn = ({ target: { name, value } }) => {
    setRenewalDueOn((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // intialData
  const loadIntialData = async () => {
    if (vehicleID !== "") {
      const obj = {
        documentNumber: vehicleID,
      };
      await logistics.getTruckMasterDetail(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          setcustomerContactPerson(item?.data[0]?.contactDetails);
          setDocumentTypeData(item.data[0]?.certifications);
          setRenewalDueOn(item.data[0]?.renewalDueOn);
          setFuelHistory(item.data[0]?.fuelHistory);
          const updatedServiceHistory = item.data[0]?.serviceHistory?.map(
            (service) => ({
              ...service,
              vehicleNumber: item.data[0]?.vehicleRegistrationNr || "",
            }),
          );

          setServiceData(updatedServiceHistory);
        } else {
          // setErrorMsg('*'+ item?.message);
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      });
    } else {
      navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_LIST);
    }
  };

  useEffect(() => {
    loadIntialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleUpdate = async () => {
    const updatedContactDetails = getcustomerContactPerson.map((doc) => ({
      ...doc,
      contactPosition: `${doc.contactPositionCode || ""} - ${
        doc.contactPositionDesc || ""
      }`,
      contactTitle: `${doc.contactTitleCode || ""}`,
    }));

    const updatedCertifications = getDocumentTypeData.map((doc) => ({
      ...doc,
      documentType: `${doc.documentTypeCode || ""} - ${
        doc.documentTypeDesc || ""
      }`,
    }));
    const updatedServiceHistory = getServiceData.map((item) => ({
      ...item,
      serviceCreated: false,
    }));

    const obj = {
      ...formInputs,
      contactDetails: updatedContactDetails,
      certifications: updatedCertifications,
      renewalDueOn: getRenewalDueOn,
      serviceHistory: updatedServiceHistory,
    };
    await logistics.updateTruckMaster(obj).then((item) => {
      setDisable(true);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants.LOGISTICS_MASTER_VEHICLE_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisable(false);
    });
  };
  useEffect(() => {
    if (formInputs) {
      setupdateLogisticsTransport((prev) => ({
        ...prev,
      }));
    }
  }, [formInputs]);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      if (item?.status === 200) {
        //   setCountry(item?.data);
        // } else {
        //   setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    let obj4 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj4).then((item) => {
      if (item?.status === 200) {
        //   setCompanyCode(item?.data);
        // } else {
        //   setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      if (item?.status === 200) {
        //   setState(item?.data);
        // } else {
        //   setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id,
    );
    setcustomerContactPerson(updatedData1);
  };
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };
  const handleChangeCustomerContacts = (id, fieldName, value) => {
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
  };
  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };

  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
  };

  /* ---------------------project details block-------- */

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData?.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //bank start

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        //   setBankDetailsData(item?.data);
        // } else {
        //   setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Bank Info Section
  const [editMode, setEditMode] = useState(true);

  const TrasnportUpdate = () => {
    setEditMode(false);
  };
  const cancelUpdate = () => {
    setEditMode(true);
  };

  //bank end

  const [getServiceData, setServiceData] = useState([]);

  const [getShowServiceModal, setShowServiceModal] = useState(false);
  const hideSupplierInviteModal = () => setShowServiceModal(false);
  const vehicleServices = () => {
    setShowServiceModal(true);
  };
  const handleSaveService = (data) => {
    setServiceData(data?.serviceHistory);
  };

  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Vehicle Details
              {formInputs?.activeInactive ? (
                <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                  Active
                </span>
              ) : (
                <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                  Inactive
                </span>
              )}
            </h2>
            <p className="subText">
              Details as a new Vehicle or Sub-Contractor with our Company
            </p>
            <hr />
            <Row className="mb-4">
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              ></Col>
            </Row>
            <Row className="mb-4">
              {/* edit button */}
              {editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 10 }}
                  lg={{ span: 2, offset: 10 }}
                  className="text-left"
                >
                  {/* {hasAccess(
                                userRole,
                                "buttons",
                                "customer_details_edit",
                                pageConfigInfo
                              ) && ( */}
                  <Col xs={6} md={2} lg={2} className="text-left">
                    <button className="btnInfo" onClick={TrasnportUpdate}>
                      Edit
                    </button>
                  </Col>
                  {/* )} */}
                </Col>
              )}
              {!editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className="text-left"
                >
                  <button
                    className="btn btnInfo"
                    onClick={handleUpdate}
                    disabled={getDisabled}
                  >
                    Update
                  </button>
                </Col>
              )}
              {!editMode && (
                <Col xs={6} md={2} lg={2} className="text-left">
                  <button
                    className="btn btnInfo btn-danger"
                    onClick={cancelUpdate}
                    disabled={getDisabled}
                  >
                    Cancel
                  </button>
                </Col>
              )}
            </Row>
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VE</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Vehicle </span>
                      <span className="subHeaderTitle">Vehicle Details</span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="me-2">
                      <button className="btnTable" onClick={vehicleServices}>
                        Add Service
                      </button>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vehicle Registration Nr"
                          name="vehicleRegistrationNr"
                          placeholder=""
                          value={formInputs?.vehicleRegistrationNr}
                          onChange={onInputChange}
                          error={validation?.vehicleRegistrationNr}
                          required={true}
                          // disabled={true}
                          disabled={editMode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Registration Date"
                          type="date"
                          name="refregistrationDate"
                          // min="2023-01-01"
                          // max="2023-12-31"
                          min={2023}
                          placeholder=""
                          value={formInputs.refregistrationDate || ""}
                          onChange={onInputChange}
                          error={validation.refregistrationDate}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Manufacture Make"
                          name="manufactureMake"
                          placeholder=""
                          value={formInputs?.manufactureMake}
                          onChange={onInputChange}
                          error={validation?.manufactureMake}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Make Model"
                          name="makeModel"
                          placeholder=""
                          value={formInputs.makeModel || ""}
                          onChange={onInputChange}
                          error={validation.makeModel}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Chassis Number"
                          name="chassisNr"
                          placeholder=""
                          value={formInputs?.chassisNr}
                          onChange={onInputChange}
                          error={validation?.chassisNr}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Engine Number"
                          name="engineNr"
                          placeholder=""
                          value={formInputs?.engineNr}
                          onChange={onInputChange}
                          error={validation?.engineNr}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="No of Tyres"
                          placeholder=""
                          data={noOfTyresOptions}
                          id="noOfTyres"
                          iconClassName="dropdownIcon"
                          name="noOfTyres"
                          required={true}
                          setValue={formInputs?.noOfTyres || ""}
                          onChange={onInputChange}
                          getvalue={setDropdownData}
                          // disabled={true}
                          disabled={editMode}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Capacity MT"
                          name="capacityMT"
                          placeholder=""
                          value={formInputs?.capacityMT}
                          onChange={onInputChange}
                          error={validation?.capacityMT}
                          required={true}
                          // disabled={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Owner Name"
                          name="ownername"
                          placeholder=""
                          value={formInputs?.ownername || ""}
                          onChange={onInputChange}
                          error={validation?.ownername}
                          required={true}
                          // disabled={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Type"
                          placeholder=""
                          data={typeOptions}
                          id="type"
                          iconClassName="dropdownIcon"
                          name="type"
                          required={true}
                          setValue={formInputs?.type || ""}
                          // onChange={onInputChange}
                          // getvalue={setDropdownData}
                          disabled={editMode}
                          // disabled={getDisabledStatus}
                          // className="dropdownOption"
                        />
                      </Col>
                      {formInputs.type === "Hired" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transporter"
                            name="transporter"
                            placeholder=""
                            setValue={formInputs?.transporter}
                            onChange={onInputChange}
                            error={validation?.transporter}
                            required={true}
                            disabled={editMode}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >
                        <ComboboxField
                          label="Ref Vehicle"
                          placeholder=""
                          data={refVehicleOptions}
                          id="type1"
                          iconClassName="dropdownIcon"
                          name="type1"
                          required={true}
                          setValue={formInputs.type1}
                          getvalue={setDropdownData}
                          disabled={editMode}
                          // disabled={getDisabledStatus}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="activeInactive"
                          >
                            Active/Inactive
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="activeInactive"
                            id="activeInactive"
                            checked={formInputs?.activeInactive || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                activeInactive: e.target.checked,
                              }))
                            }
                            disabled={editMode}
                          />
                          <span className="ms-2">
                            {formInputs?.activeInactive ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    {!editMode && (
                      <Col xs={4} md={2} lg={2}>
                        <div className="d-flex justify-content-end  p-2 me-3">
                          <button
                            className="btnTable"
                            onClick={addCustomerCantactPerson}
                          >
                            <i className="bi bi-plus-lg"></i> Add
                          </button>
                        </div>
                      </Col>
                    )}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson?.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              disabled={editMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              disabled={editMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value,
                                                )
                                              }
                                              disabled={editMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value,
                                                )
                                              }
                                              disabled={editMode}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value,
                                                )
                                              }
                                              disabled={editMode}
                                            />
                                          </Col>
                                          {!editMode && (
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={1}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <i
                                                onClick={() =>
                                                  deleteCustomerContactPerosn(
                                                    doc.id,
                                                  )
                                                }
                                                className="bi bi-trash text-danger fs-4"
                                              />
                                            </Col>
                                          )}
                                        </Row>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RD</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Renewal DueOn </span>
                      <span className="subHeaderTitle">Vehicle Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="State Permit"
                          name="statePermit"
                          id="statePermit"
                          placeholder="State Permit"
                          data={statePermitOptions}
                          iconClassName="dropdownIcon"
                          code="statePermitCode"
                          setValue={formInputs?.statePermit || ""}
                          disabled={editMode}
                          onChange={onInputChangerenewalDueOn}
                          required={true}
                          getvalue={setDropdownData}
                          // error={validation.statePermit}
                        />
                      </Col>
                      {formInputs?.statePermit === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="State Permit Date"
                            name="statePermitDate"
                            id="statePermitDate"
                            disabled={editMode}
                            value={getRenewalDueOn?.statePermitDate}
                            onChange={onInputChangerenewalDueOn}
                            required={true}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <ComboboxField
                          className="inputBox"
                          label="National Permit"
                          name="nationalPermit"
                          id="nationalPermit"
                          placeholder="National Permit"
                          data={nationalPermitOptions}
                          iconClassName="dropdownIcon"
                          code="nationalPermitCode"
                          setValue={formInputs?.nationalPermit || ""}
                          onChange={onInputChangerenewalDueOn}
                          required={true}
                          disabled={editMode}
                          getvalue={setDropdownData}
                          // error={validation.statePermit}
                        /> */}
                        <ComboboxField
                          className="inputBox"
                          label="National Permit"
                          name="refnationalPermit"
                          id="nationalPermit"
                          placeholder="National Permit"
                          data={nationalPermitOptions}
                          iconClassName="dropdownIcon"
                          code="nationalPermitCode"
                          setValue={formInputs?.refnationalPermit || ""}
                          onChange={onInputChangerenewalDueOn}
                          //  required={true}
                          getvalue={setDropdownData}
                          error={validation.statePermit}
                          disabled={editMode}
                        />
                      </Col>
                      {formInputs?.refnationalPermit === "Yes" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="National Permit Date"
                            name="nationalPermitDate"
                            id="nationalPermitDate"
                            value={getRenewalDueOn?.nationalPermitDate || ""}
                            disabled={editMode}
                            onChange={onInputChangerenewalDueOn}
                            required={true}
                          />
                        </Col>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Road Tax"
                          name="roadTax"
                          type="date"
                          placeholder=""
                          value={getRenewalDueOn?.roadTax || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.roadTax}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Fitness"
                          name="fitness"
                          type="date"
                          placeholder=""
                          value={getRenewalDueOn?.fitness || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.fitness}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance"
                          name="insuranceNr"
                          placeholder=""
                          value={getRenewalDueOn?.insuranceNr || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.insuranceNr}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance Date"
                          name="insuranceDate"
                          placeholder=""
                          type="date"
                          value={formInputs?.renewalDueOn?.insuranceDate || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation.insuranceDate}
                          required={true}
                          disabled={true}

                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Insurance Expiry Date"
                          name="insuranceExpiryDate"
                          placeholder=""
                          type="date"
                          value={getRenewalDueOn?.insuranceExpiryDate || ""}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.insuranceExpiryDate}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Pollution"
                          name="pollution"
                          placeholder=""
                          value={getRenewalDueOn?.pollution}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.pollution}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="AMC"
                          name="AMC"
                          type="date"
                          placeholder=""
                          value={getRenewalDueOn?.AMC}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.AMC}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Renewal Capacity"
                          name="renewalCapacityMT"
                          placeholder=""
                          value={formInputs?.renewalDueOn?.renewalCapacityMT}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.renewalCapacityMT}
                          required={true}
                          disabled={true}

                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commLeftRightPadding"
                      >

                        
                        <ComboboxField
                          label="Renewal No of Tyres"
                          placeholder=""
                          data={renewalNoOfTyresOptions}
                          id="renewalNoOfTyresOptions"
                          iconClassName="dropdownIcon"
                          name="renewalNoOfTyresOptions"
                          required={true}
                          // onChange={onInputChange}
                          setValue={formInputs?.renewalNoOfTyres}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.renewalNoOfTyres}
                          getvalue={setDropdownData}
                        disabled={true}
                        // className="dropdownOption"
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Tyre Numbers"
                          name="tyreNumbers"
                          placeholder=""
                          value={formInputs?.renewalDueOn?.tyreNumbers}
                          onChange={onInputChangerenewalDueOn}
                          error={validation?.tyreNumbers}
                          required={true}
                          disabled={true}

                        />
                      </Col> */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    {!editMode && (
                      <Col xs={4} md={2} lg={2}>
                        <div className="d-flex justify-content-end  p-2 me-3">
                          <button
                            className="btnTable"
                            onClick={addDocumentType}
                          >
                            <i className="bi bi-plus-lg"></i> Add
                          </button>
                        </div>
                      </Col>
                    )}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  {getDocumentTypeData && getDocumentTypeData.length !== 0 ? (
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            <div className="d-flex-column justify-content-center">
                              <Row>
                                <Col xs={12}>
                                  <div className="accordion-body">
                                    <div className="d-flex-column justify-content-center">
                                      <Row className="pt-4 d-none d-lg-flex ">
                                        <Col xs={12} md={4} lg={2}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            Document Type
                                          </p>
                                        </Col>
                                        <Col xs={12} md={4} lg={2}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            Document Number
                                          </p>
                                        </Col>
                                        <Col xs={12} md={4} lg={2}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            Issue Date
                                          </p>
                                        </Col>
                                        <Col xs={12} md={4} lg={1}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            View Files
                                          </p>
                                        </Col>
                                        <Col xs={12} md={4} lg={2}>
                                          <p className="fs-6 fw-medium d-flex ms-4">
                                            Attachments
                                          </p>
                                        </Col>
                                        {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col> */}
                                      </Row>
                                      {getDocumentTypeData?.map(
                                        (doc, index) => (
                                          <Row key={doc.id}>
                                            <Col xs={12}>
                                              <hr className="mx-4 my-0 text-color-black" />
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={2}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <ComboboxField
                                                label=""
                                                placeholder="Document type"
                                                data={getdocumentType}
                                                id="documentType"
                                                iconClassName="dropdownIcon"
                                                name="documentType"
                                                code="documentTypeCode"
                                                description="documentTypeDesc"
                                                setValue={doc?.documentType}
                                                getvalue={setDropdownData}
                                                index={doc.id}
                                                onChangeValue={
                                                  handleInputChange
                                                }
                                                disabled={editMode}
                                              />
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={2}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <InputField
                                                className="inputBox"
                                                placeholder="Document Number"
                                                value={doc.documentNumber}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    doc.id,
                                                    "documentNumber",
                                                    e.target.value,
                                                  )
                                                }
                                                disabled={editMode}
                                              />
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={2}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <InputField
                                                className="inputBox"
                                                type="date"
                                                value={doc?.issueDate}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    doc.id,
                                                    "issueDate",
                                                    e.target.value,
                                                  )
                                                }
                                                disabled={editMode}
                                              />
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={1}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <div className="d-flex justify-content-center">
                                                {(doc.iSOCertification && (
                                                  <img
                                                    src="assets/img/newIcons/attached-file.png"
                                                    className="mt-1 attachmentIcon"
                                                    alt="attachments"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        doc.iSOCertification,
                                                      )
                                                    }
                                                    disabled={editMode}
                                                  />
                                                )) ||
                                                  "--"}
                                              </div>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={3}
                                              className="commTopButtonRightLeftPadding"
                                            >
                                              <FileUploadComponent
                                                id={doc.id}
                                                name="iSOCertification"
                                                label=""
                                                allowedTypes={[
                                                  "image/png",
                                                  "image/jpeg",
                                                  "application/pdf",
                                                ]}
                                                multiple={true} // Change to `false` for single file selection
                                                required={true}
                                                onSuccessUpload={
                                                  onSuccessUploadDocumentType
                                                }
                                                value={
                                                  doc.iSOCertification || ""
                                                }
                                                disabled={editMode}
                                              />
                                            </Col>
                                            {!editMode && (
                                              <Col
                                                xs={12}
                                                md={4}
                                                lg={1}
                                                className="commTopButtonRightLeftPadding"
                                              >
                                                <i
                                                  onClick={() =>
                                                    deleteDocumentType(doc.id)
                                                  }
                                                  className="bi bi-trash text-danger fs-4"
                                                />
                                              </Col>
                                            )}
                                          </Row>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <span className="m-4  d-flex justify-content-center">
                      There is no data to display
                    </span>
                  )}
                </div>
              </div>
            </div>
            {formInputs.type1 === "Yes" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible4
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RV</span>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        <span className="headerTitle">Ref Vehicle </span>
                        <span className="subHeaderTitle">
                          Ref Vehicle Registration
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible4 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vehicle RegistrationNo"
                            name="refvehicleRegistrationNr"
                            placeholder=""
                            value={formInputs.refvehicleRegistrationNr || ""}
                            onChange={onInputChange}
                            // required={true}
                            disabled={editMode}
                            error={validation.refvehicleRegistrationNr}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Registration Date"
                            type="date"
                            name="refregistrationDate"
                            // min="2023-01-01"
                            // max="2023-12-31"
                            min={2023}
                            placeholder=""
                            value={formInputs.refregistrationDate || ""}
                            onChange={onInputChange}
                            error={validation.refregistrationDate}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Manufacture Make"
                            name="refmanufactureMake"
                            placeholder=""
                            value={formInputs.refmanufactureMake || ""}
                            onChange={onInputChange}
                            error={validation.refmanufactureMake}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Make Model"
                            name="refmakeModel"
                            placeholder=""
                            value={formInputs.refmakeModel || ""}
                            onChange={onInputChange}
                            error={validation.refmakeModel}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Chessis Number"
                            name="refchassisNr"
                            placeholder=""
                            value={formInputs.refchassisNr || ""}
                            onChange={onInputChange}
                            error={validation.refchassisNr}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Engine Number"
                            name="refengineNr"
                            placeholder=""
                            value={formInputs.refengineNr || ""}
                            onChange={onInputChange}
                            error={validation.refengineNr}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="No of Tyres"
                            placeholder=""
                            data={noOfTyresOptions}
                            id="noOfTyres"
                            iconClassName="dropdownIcon"
                            name="refnoOfTyres"
                            // required={true}
                            setValue={formInputs?.refnoOfTyres}
                            onChange={onInputChange}
                            getvalue={setDropdownData}
                            disabled={editMode}
                            // disabled={getDisabledStatus}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Capacity MT"
                            name="refcapacityMT"
                            placeholder=""
                            value={formInputs.refcapacityMT || ""}
                            onChange={onInputChange}
                            error={validation.refcapacityMT}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Owner Name"
                            name="refownername"
                            placeholder=""
                            value={formInputs.refownername || ""}
                            onChange={onInputChange}
                            error={validation.refownername}
                            // required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type"
                            placeholder=""
                            data={typeOptions}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="reftype"
                            // required={true}
                            setValue={formInputs.reftype}
                            getvalue={setDropdownData}
                            // disabled={getDisabledStatus}
                            // className="dropdownOption"
                            disabled={editMode}
                          />
                        </Col>
                        {formInputs.reftype === "Hired" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Transporter"
                              name="reftransporter"
                              placeholder=""
                              value={formInputs.reftransporter || ""}
                              onChange={onInputChange}
                              // error={validation.reftransporter}
                              // required={true}
                              disabled={editMode}
                            />
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {formInputs.type1 === "Yes" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">RD</span>
                      </Col>
                      <Col xs={8} md={8} lg={8}>
                        <span className="headerTitle">Ref Renewal DueOn </span>
                        <span className="subHeaderTitle">
                          Ref Vehicle Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="State Permit"
                            name="refstatePermit"
                            id="statePermit"
                            placeholder="State Permit"
                            data={statePermitOptions}
                            iconClassName="dropdownIcon"
                            code="statePermitCode"
                            setValue={formInputs?.refstatePermit || ""}
                            onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            getvalue={setDropdownData}
                            disabled={editMode}
                            // error={validation.statePermit}
                          />
                        </Col>

                        {formInputs?.refstatePermit === "Yes" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="State Permit Date"
                              name="refstatePermitDate"
                              id="refstatePermitDate"
                              min={2023}
                              value={getRenewalDueOn?.refstatePermitDate || ""}
                              onChange={onInputChangerenewalDueOn}
                              disabled={editMode}
                              //  required={true}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            label="National Permit"
                            name="refnationalPermit"
                            id="nationalPermit"
                            placeholder="National Permit"
                            data={nationalPermitOptions}
                            iconClassName="dropdownIcon"
                            code="nationalPermitCode"
                            setValue={formInputs?.refnationalPermit || ""}
                            onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            disabled={editMode}
                            getvalue={setDropdownData}
                            // error={validation.statePermit}
                          />
                        </Col>
                        {formInputs?.refnationalPermit === "Yes" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="National Permit Date"
                              name="refnationalPermitDate"
                              id="refnationalPermitDate"
                              min={2023}
                              value={
                                getRenewalDueOn?.refnationalPermitDate || ""
                              }
                              onChange={onInputChangerenewalDueOn}
                              //  required={true}
                              disabled={editMode}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Road Tax"
                            name="refroadTax"
                            id="refroadTax"
                            min={2023}
                            value={getRenewalDueOn?.refroadTax || ""}
                            onChange={onInputChangerenewalDueOn}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Fitness"
                            name="reffitness"
                            type="date"
                            min={2023}
                            placeholder=""
                            value={getRenewalDueOn?.reffitness || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.reffitness}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Insurance"
                            name="refinsuranceNr"
                            placeholder=""
                            value={getRenewalDueOn?.refinsuranceNr || ""}
                            onChange={onInputChangerenewalDueOn}
                            error={validation?.refinsuranceNr}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Insurance Expiry Date"
                            name="refinsuranceExpiryDate"
                            placeholder=""
                            type="date"
                            min={2023}
                            value={
                              getRenewalDueOn?.refinsuranceExpiryDate || ""
                            }
                            onChange={onInputChangerenewalDueOn}
                            error={validation.refinsuranceExpiryDate}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Pollution"
                            name="refPollution"
                            placeholder=""
                            value={getRenewalDueOn?.refPollution}
                            onChange={onInputChangerenewalDueOn}
                            error={validation?.refPollution}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="AMC"
                            name="refAmc"
                            placeholder=""
                            type="date"
                            min={2023}
                            value={getRenewalDueOn?.refAmc}
                            onChange={onInputChangerenewalDueOn}
                            error={validation.refAmc}
                            //  required={true}
                            disabled={editMode}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {getFuelHistory?.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">FH</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Fuel History</span>
                          <span className="subHeaderTitle">
                            Fuel History Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={fuelHistoryColum}
                              data={getFuelHistory}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={
                              //   Constants.ROW_PER_PAGE
                              // }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {getServiceData?.length > 0 && (
              <>
                <div className="accordion my-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SH</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Service History</span>
                          <span className="subHeaderTitle">
                            Service History Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={serviceHistoryColumn}
                              data={getServiceData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={
                              //   Constants.ROW_PER_PAGE
                              // }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Project Details*/}
          </div>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        // requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <VehicleServiceHistory
        show={getShowServiceModal}
        onHide={hideSupplierInviteModal}
        onSave={handleSaveService}
        getServiceData={getServiceData}
        editMode={editMode}
        vehicleRegistrationNr={formInputs?.vehicleRegistrationNr}

        // onSubmit={inviteSupplier}
        // data={selectedRowData}
      />
    </main>
  );
};

export default PlVehicleDetails;
